
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/previewer/components/previewerItem.scss.css.virtualfile';
        module.exports = {"item":"_item_15i40_1","overlay":"_overlay_15i40_5"};